import React, { useEffect, useState, useContext, useMemo, useCallback } from 'react'
import TripsContext from '../../contexts/TripsContext'
import { useMarkers } from '../../hooks/useMarker'
import OverlayMarker from '../OverlayMarker'
import InfoWindowMarker, { ICON_START } from '../InfoWindowMarker'
import moment from 'moment'
import MarkerTrip from '../MarkerTrip'
import OverlayCar from '../OverlayCar'
import { buildReverseGeocodeId } from '../../api/google-integration'
import { useReverseGeocode } from '../../hooks/useReverseGeocode'
import { InfoWindow } from '@react-google-maps/api'
import styled from 'styled-components'
import { getDistance } from '../../utils'
import { createMarkerInfoWindow } from '../../infowindow-utils'
import { ICON_END } from '../InfoWindowMarker/index'

const MarkersTrip = () => {
    const {
        mapInstance,
        trips,
        tripActive,
        reverseGeocoding,
        hardwareData,
        isNavegateToTrips,
        setInfoWindow
    } = useContext(TripsContext)
    const [carPosition, setCarPosition] = useState<any>()
    const [tripStart, setTripStart] = useState<any>()
    const [tripEnd, setTripEnd] = useState<any>()
    const { fillGoogleReverseLatLng } = useReverseGeocode()

    const openInfoWindow = useCallback((prop, type, reverseGeocoding) => {
        const popup = createMarkerInfoWindow(prop, type, reverseGeocoding)
        popup.onClose = () => {
            setInfoWindow(undefined)
        }
        setInfoWindow(popup)
    }, [])

    useEffect(() => {
        if (tripActive?.wayPoints) {
            const { avarageSpeed, travelledDistance } = tripActive
            const start = tripActive?.wayPoints[0] || {}
            const end = tripActive?.wayPoints[tripActive.wayPoints.length - 1] || {}

            fillGoogleReverseLatLng([
                { lat: start.lat, lng: start.lng },
                { lat: end.lat, lng: end.lng }
            ])

            setTripStart(start)
            setTripEnd({ ...end, ...{ avarageSpeed, travelledDistance } })
        } else {
            setTripStart(undefined)
            setTripEnd(undefined)
        }
    }, [tripActive])

    useEffect(() => {
        if (isNavegateToTrips) {
            const { imei } = isNavegateToTrips?.vehicle || {}
            const hw = hardwareData?.[imei]
            const { lat, lng, angle } = hw || {}

            if (lat && lng) setCarPosition({ lat, lng, angle })
            else setCarPosition(undefined)
        } else {
            setCarPosition(undefined)
        }
    }, [isNavegateToTrips])

    const Marker = ({ data, type }: any): JSX.Element => {
        const icon = 'fas ' + (type === 1 ? 'fa-location' : 'fa-flag-checkered')
        const { lat, lng } = data

        return (
            <OverlayMarker
                position={{ lat, lng }}
                backgroundColor="blue-500"
                borderColor="gray-0"
                color="gray-0"
                customIcon={
                    <div style={{ position: 'absolute' }} onClick={() => openInfoWindow(data, type, reverseGeocoding)}>
                        <ContainerIcons style={{ top: -15 }}>
                            <Icon size={28} color="gray-0">
                                <i className="fas fa-map-marker" />
                            </Icon>

                            <Icon opacity="1" size="25" color="blue-500">
                                <i className="fas fa-map-marker"></i>
                            </Icon>

                            <Icon size="13" color="gray-0">
                                <i className={icon} />
                            </Icon>
                        </ContainerIcons>
                    </div>
                }
            />
        )
    }

    return (
        <>
            {carPosition && (
                <OverlayCar position={{ lat: carPosition?.lat, lng: carPosition?.lng }} angle={carPosition?.angle} />
            )}

            {tripStart && tripStart.lat && tripStart.lng && <Marker type={ICON_START} data={tripStart} />}

            {tripEnd &&
                tripEnd.lat &&
                tripEnd.lng &&
                carPosition?.lat !== tripEnd.lat &&
                carPosition?.lng !== tripEnd.lng && <Marker type={ICON_END} data={tripEnd} />}
        </>
    )
}

export default React.memo(MarkersTrip)

const ContainerIcons = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`

const Icon = styled.div`
    opacity: ${({ opacity }) => opacity};
    position: absolute;
    font-size: ${({ size }) => `${size}px`};
    color: ${({ theme, color }) => (theme[color] ? theme[color] : color)};
`
